import React from 'react';
import axios from 'axios';
import useStores from '../hooks/useStores';

const AxiosConfig = () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.defaults.withCredentials = true;
    const { authStore } = useStores();
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response.status === 401) {
                authStore.setAuthorized(false);
            }
            return Promise.reject(error);
        },
    );

    return <></>;
};

export default AxiosConfig;
